import { createContext } from 'react';

import type { FormValues } from 'src/app/pages/petitionDetails/shared/types';

export type MobileSignFormContextValues = {
	mobileSignFormValues: FormValues | undefined;
	updateMobileSignFormValues: (values: FormValues) => void;
};

export const MobileSignFormContext = createContext<MobileSignFormContextValues | undefined>(undefined);
